export default "__VITE_ASSET__b9260803__"